import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-741d36ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "以下の内容でよろしいですか？")
], -1))
const _hoisted_4 = { class: "entry_career_company_badge" }
const _hoisted_5 = { class: "entry_career_company_name" }
const _hoisted_6 = { class: "entry_career_company_businesstype" }
const _hoisted_7 = { class: "entry_career_company_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "職種", -1))
const _hoisted_9 = { class: "entry_career_company_item_content" }
const _hoisted_10 = { class: "entry_career_company_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "在籍期間", -1))
const _hoisted_12 = {
  key: 0,
  class: "entry_career_company_item_content"
}
const _hoisted_13 = {
  key: 1,
  class: "entry_career_company_item_content"
}
const _hoisted_14 = { class: "entry_career_company_item_2coulumn" }
const _hoisted_15 = { class: "entry_career_company_item_2coulumn_left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "社員数", -1))
const _hoisted_17 = { class: "entry_career_company_item_content" }
const _hoisted_18 = { class: "entry_career_company_item_2coulumn_right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "雇用形態", -1))
const _hoisted_20 = { class: "entry_career_company_item_content" }
const _hoisted_21 = { class: "entry_career_company_item_2coulumn" }
const _hoisted_22 = { class: "entry_career_company_item_2coulumn_left" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "月収", -1))
const _hoisted_24 = { class: "entry_career_company_item_content" }
const _hoisted_25 = { class: "entry_career_company_item_2coulumn_right" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "年収", -1))
const _hoisted_27 = { class: "entry_career_company_item_content" }
const _hoisted_28 = { class: "entry_career_company_item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "職務内容", -1))
const _hoisted_30 = { class: "entry_career_company_item_content" }
const _hoisted_31 = { class: "entry_career_company_item_content_display_textarea" }
const _hoisted_32 = { class: "entry_career_company_button" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "entry_career_add" }
const _hoisted_35 = { class: "entry_career_add" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_add_text" }, [
  /*#__PURE__*/_createTextVNode(" 職歴は直近3社まで入力できます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3社目より前の職歴は後ほど提出いただく "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 履歴書・職務経歴書に詳細をご記入ください。 ")
], -1))
const _hoisted_37 = { class: "entry_career_button" }
const _hoisted_38 = { class: "entry_career_button_prev" }
const _hoisted_39 = { class: "entry_career_button_next" }

import { Ref, ref, computed } from 'vue';
import store from '@/store';
import { useRouter } from 'vue-router';
import Indicator from '@/components/Indicator.vue';
import Loading from '@/components/Loading.vue';
import BaseButton from '@/components/BaseButton.vue';
import { getMasterDataListEmpTypeBusicr, MasterEmpTypeBusicr } from '@/api/masterDataEndpoint';
import { getWorkHistoryInfo, WorkHistoryInfo } from '@/api/careersheetEndpoint';

type WorkHistoryList = WorkHistoryInfo[];

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyconfirmView',
  setup(__props) {

const isLoading = ref(false);
const empTypeBusicrList = ref<MasterEmpTypeBusicr[]>([]);

const workHistoryList: Ref<WorkHistoryList> = ref([]);

const init = async () => {
  try {
    const workHisRes = await getWorkHistoryInfo();
    store.commit('entryCareerCompany/setMaxBusicrId', workHisRes.maxBusicrId);
    workHistoryList.value = [...workHisRes.workHisInfoList].sort((a, b) => a.busicrId - b.busicrId);
    empTypeBusicrList.value = await getMasterDataListEmpTypeBusicr();
  } catch (e) {
    console.error(e);
  }
};
init();

// 選択した雇用形態の値に該当するテキストを設定する
const getEmpTypeBusicrText = computed(() => (emptypeId: number) => {
  return empTypeBusicrList.value.find((i) => i.code === emptypeId)?.name;
});
// read-moreの管理
const isCloseItem = ref([true, true, true]);
// 離職中or現職フラグ
const isRetirement = (wkperiodeDateyr: number | null, wkperiodeDatemon: number | null) => {
  return wkperiodeDateyr && wkperiodeDatemon;
};

const router = useRouter();
const addNewItem = () => {
  store.commit('entryCareerCompany/setEditingBusicrId', null);
  router.push({ name: 'c03' });
};
const transitionPreviousPage = () => {
  router.push({ name: 'c02' });
};
const transitionEditWorkHistory = async (busicrId: number) => {
  isLoading.value = true;
  try {
    store.commit('entryCareerCompany/setEditingBusicrId', busicrId);
    await store.dispatch('entryCareerCompany/getWorkHistoryDetailInfo', busicrId);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
    router.push({ name: 'c03' });
  }
};

const transitionNextPage = async () => {
  router.push({ name: 'c07' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Indicator, {
            current: 5,
            max: 12
          })
        ]),
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workHistoryList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: _normalizeClass(["entry_career_company", { 'is-readmore-close': isCloseItem.value[index] }])
            }, [
              _createElementVNode("div", _hoisted_4, "職歴" + _toDisplayString(index + 1), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.compname), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.indsctgName), 1),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.busicrOcupctgName), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                (isRetirement(item.wkperiodeDateyr, item.wkperiodeDatemon))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.wkperiodsDateyr) + "." + _toDisplayString(item.wkperiodsDatemon) + "〜" + _toDisplayString(item.wkperiodeDateyr) + "." + _toDisplayString(item.wkperiodeDatemon), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, "在籍中 " + _toDisplayString(item.wkperiodsDateyr) + "." + _toDisplayString(item.wkperiodsDatemon) + "〜現在", 1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.employeeNum ? item.employeeNum : '-') + "人", 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(getEmpTypeBusicrText)(item.emptypeId)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(item.salary ? item.salary : '-') + "万円", 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, _toDisplayString(item.annualincm ? item.annualincm : '-') + "万円", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("pre", _hoisted_31, _toDisplayString(item.wkcontents), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  class: _normalizeClass(["button_readmore", { 'is-close': !isCloseItem.value[index] }]),
                  onClick: ($event: any) => (isCloseItem.value[index] = !isCloseItem.value[index])
                }, _toDisplayString(isCloseItem.value[index] ? 'もっと見る' : '閉じる'), 11, _hoisted_33)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(BaseButton, {
                onClick: ($event: any) => (transitionEditWorkHistory(item.busicrId)),
                theme: "tertiary",
                type: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 職歴" + _toDisplayString(index + 1) + "を編集する ", 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_35, [
          (workHistoryList.value.length < 3)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 0,
                onClick: addNewItem,
                theme: "secondary",
                type: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("＋職歴を追加する")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_36
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(BaseButton, {
              onClick: transitionPreviousPage,
              theme: "tertiary",
              type: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(BaseButton, {
              onClick: transitionNextPage,
              theme: "primary",
              type: "button",
              disabled: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("次へ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}
}

})